export enum SiteRegion {
    QA = 'QA',
    STAGE = 'STAGE',
    CN = 'CN',
    US = 'US',
    EU = 'EU',
}

export function getSiteRegion(): SiteRegion {
    const mockRegion = localStorage.getItem('_MOCK_SITE_REGION_');
    if (mockRegion) {
        return mockRegion?.toUpperCase() as SiteRegion;
    }
    const origin = window.location.origin;
    if (origin.indexOf('qa-eureka.zhihuiya.com') > -1) {
        return SiteRegion.QA;
    } else if (origin.indexOf('stage-eureka.zhihuiya.com') > -1) {
        return SiteRegion.STAGE;
    } else if (origin.indexOf('eureka.zhihuiya.com') > -1) {
        return SiteRegion.CN;
    } else if (origin.indexOf('eureka.patsnap.com') > -1) {
        return SiteRegion.US;
    } else if (origin.indexOf('eureka.patsnap.eu') > -1) {
        return SiteRegion.EU;
    }
    return SiteRegion.QA;
}

export function getIsOverseas() {
    const siteRegion = getSiteRegion();
    return ![SiteRegion.QA, SiteRegion.CN].includes(siteRegion);
}
